import React from 'react'

import foodie from '../../images/FOODIE.jpg'
import foodie2 from '../../images/FOODIE 2.jpg'
import foodieTestimonial from '../../images/FOODIE TESTIMONIAL.jpg'

function Foodie() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={foodie}
            className="project-image" />
          <img
            src={foodie2}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Foodie</h1>
          <p className="Project-text">
            <strong>
            Short Film
            <br />
Someday Stories, Maori TV
            <br />

Director: Mia Maramara
            <br />
            2018
            <br />
            <br />

Rehearsal + On Set Acting Coach
            <br />
Coached lead actor, Jenesis (age 8)
            </strong>
          </p>
          <p className="Project-testimonial">
            "As a director, it was my first time working with a child actor and Ella was an indispensable part of helping me get the performance I needed. She laid out an amazing game plan and followed through with great conviction from start to finish. With her help, our actor was able to prepare herself for the role and feel comfortable enough to work her magic on set.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Mia Maramara</strong>
          </h6>
          <br />
          <img 
            src={foodieTestimonial}
            className="testimonial-img"/>
        </div>
      </div>
    </div>
  )
}

export default Foodie
